<template>
  <div>
    <vue-excel-editor class="mt-2" ref="grid" v-model="items" no-header-edit disable-panel-filter :new-if-bottom="newIfBottom" :free-select="false" :readonly="readOnly" @select="onSelect" @update="onUpdate">
      <!-- <vue-excel-column field="startTime" :change="recomputeEndTime" :label="this.$t('vesselActivities.startTime')" :to-text="dateTimeToText" :to-value="textToDateTime" :validate="validDateTime" text-align="center" width="150px" /> -->
      <!-- <vue-excel-column field="endTime" :label="this.$t('vesselActivities.endTime')" :to-text="dateTimeToText" :to-value="textToDateTime" :validate="validDateTime" text-align="center" width="150px" readonly /> -->
      <vue-excel-column field="date" label="Date" :to-text="dateToText" :to-value="textToDate" :validate="validDate" :change="onDateChange" :readonly="ifNotCommulative" text-align="center" width="150px"  :sort="() => false" />
      <vue-excel-column field="timeCompiling" :change="onTimeCompilingChange" :label="this.$t('vesselActivities.timeCompiling')" :to-text="durationToText" :to-value="textToDuration" :validate="validTime" text-align="center" width="100px"  :sort="() => false" />
      <vue-excel-column field="remarks" type="string" :label="this.$t('vesselActivities.remarks')" width="250px"  :sort="() => false" />
      <vue-excel-column field="cableId" type="map" :label="this.$t('vesselActivities.cable')" :options="cablesMap" width="250px"  :sort="() => false" />
      <vue-excel-column field="lineCode" type="string" :label="this.$t('vesselActivities.lines')" width="150px"  :sort="() => false" />
      <vue-excel-column field="roToStartKp" type="number" :label="this.$t('vesselActivities.ROTOStart')" readonly text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="roToEndKp" type="number" :label="this.$t('vesselActivities.ROTOEnd')" :change="onRotoEndChange" :validate="validRotoEnd" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="progress" type="string" :label="this.$t('vesselActivities.progress')" :to-text="numberToText" :to-value="textToNumber" text-align="right" width="100px" readonly  :sort="() => false" />
      <vue-excel-column field="deltaT" type="string" :label="this.$t('vesselActivities.deltat')" text-align="right" width="100px" readonly  :sort="() => false" />
      <vue-excel-column field="activityId" type="map" :change="recomputeActivityFields" :label="this.$t('vesselActivities.codeActivity')" :options="activityNameMap" width="250px"  :sort="() => false" />
      <vue-excel-column field="macroActivityId" type="map" :label="this.$t('vesselActivities.macroActivities')" :options="macroActivitiesMap" width="250px"  :sort="() => false" />
      <vue-excel-column field="activityCategory" type="string" :label="this.$t('actMaster.category')" width="250px" readonly :sort="() => false"  />
      <vue-excel-column field="tool" type="string" readonly :label="this.$t('actMaster.tool')" width="250px"  :sort="() => false" />
      <vue-excel-column field="vesselStartKp" type="number" :change="onVesselStartChange" :label="this.$t('vesselActivities.vesselStart')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="vesselEndKp" type="number" :change="onVesselProgressChange" :label="this.$t('vesselActivities.vesselEnd')" text-align="right" width="100px" :sort="() => false"  />
      <vue-excel-column field="progressVessel" type="string" :label="this.$t('vesselActivities.progressVessel')" :to-text="numberToText" :to-value="textToNumber" text-align="right" width="100px" readonly :sort="() => false"  />
      <vue-excel-column field="rovStartKp" type="number" :label="this.$t('vesselActivities.rovStart')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="rovEndKp" type="number" :label="this.$t('vesselActivities.rovEnd')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="progressRov" type="string" :label="this.$t('vesselActivities.progressRov')" :to-text="numberToText" :to-value="textToNumber" text-align="right" width="100px" readonly  :sort="() => false" />
      <vue-excel-column field="sheaveStartKp" type="number" :label="this.$t('vesselActivities.sheaveStart')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="sheaveEndKp" type="number" :label="this.$t('vesselActivities.sheaveEnd')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="progressSheave" type="string" :label="this.$t('vesselActivities.progressSheave')" :to-text="numberToText" :to-value="textToNumber" text-align="right" width="100px" readonly  :sort="() => false" />
      <vue-excel-column field="areaName" type="string" :label="this.$t('vesselActivities.area')" width="250px" readonly  :sort="() => false" />
      <vue-excel-column field="laybackTension" type="number" :label="this.$t('vesselActivities.laybackTension')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="waterDepth" type="number" :label="this.$t('vesselActivities.waterDepth')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="layingSpeed" type="string" :label="this.$t('vesselActivities.layingSpeed')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="targetDepth" type="string" readonly :label="this.$t('vesselActivities.targetDepth')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="targetSpeed" type="string" readonly :label="this.$t('vesselActivities.targetSpeed')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="estimate" type="string" readonly :label="this.$t('est.estimate')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="loweringDepth" type="number" :label="this.$t('vesselActivities.depthLowering')" text-align="right" width="100px"  :sort="() => false" />
      <vue-excel-column field="speedBret" type="map" :label="this.$t('vesselActivities.speedTreshhold')" :options="yesNoMap" width="100px"  :sort="() => false" />
      <vue-excel-column field="limitedOp" type="map" :label="this.$t('vesselActivities.limitedOperational')" :options="yesNoMap" width="100px"  :sort="() => false" />
      <vue-excel-column field="production" type="string" :label="this.$t('vesselActivities.production')" text-align="right" width="100px" readonly  :sort="() => false" />
      <vue-excel-column field="configurationId" type="map" :label="this.$t('vesselActivities.configuration')" width="150px" :options="configurationsMap"  :sort="() => false" />
      <vue-excel-column field="towTensionA" type="number" :label="this.$t('vesselActivities.towTensionA')" width="100px"  :sort="() => false" />
    </vue-excel-editor>
    <v-container fluid>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" class="mr-1" small outlined v-bind="attrs" v-on="on" elevation="1" :disabled="readOnly" @click="createItem()">
            <v-icon small color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("tooltip.vesselActivitiesCreate") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" small outlined v-bind="attrs" v-on="on" elevation="1" :disabled="readOnly" @click="deleteRecord()">
            <v-icon small color="primary">mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("tooltip.vesselActivitiesDelete") }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="isProjectClosed">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" class="ml-1" small outlined v-bind="attrs" v-on="on" elevation="1" :disabled="!readOnly" @click="cloneItems()">
            <v-icon small color="primary">mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("tooltip.vesselActivitiesClone") }}</span>
      </v-tooltip>
    </v-container>

    <v-container fluid>
      <!--  :disabled="isReadonly" @input="saveComments(true)" -->
      <v-textarea auto-grow outlined v-model="comm.ffcomments" :readonly="readOnly">
        <template v-slot:label>
          {{ $t("comments.ee") }}
        </template>
      </v-textarea>
    </v-container>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import moment from "moment";
const DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm";
const SRV_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm";
const TIME_FORMAT = "HH:mm";

const DATE_FORMAT = "DD/MMM/YYYY";
const SRV_DATE_FORMAT = "YYYY-MM-DDTHH:mm";

export default {
  name: "grid-activities",
  data() {
    return {
      readOnly: true,
      saveDisabled: true,
      timeCompiling: "00:01",
      newIfBottom: false,
      selectedRow: {},
      selectedIndex: null,
      activity: {},
      activityDefault: {
        dprMainId: null,
        startTime: null,
        endTime: null,
        timeCompiling: null,
        roToStartKp: null,
        roToEndKp: null,
        progress: null,
        cableId: null,
        deltaT: 0,
        activityId: null,
        macroActivityId: null,
        activityCategoryId: null,
        vesselStartKp: null,
        vesselEndKp: null,
        progressVessel: null,
        rovStartKp: null,
        rovEndKp: null,
        progressRov: null,
        sheaveStartKp: null,
        sheaveEndKp: null,
        progressSheave: null,
        areaName: null,
        laybackTension: null,
        waterDepth: null,
        layingSpeed: null,
        loweringDepth: null,
        remarks: null,
        speedBret: null,
        limitedOp: null,
        production: null,
        configurationId: null,
        towTensionA: null,
      },
      yesNoValues: [
        { text: "", value: null },
        { text: this.$t("common.yes"), value: true },
        { text: this.$t("common.no"), value: false },
      ],
      invisibleStatesMap: {},
      // valid: false,
      currentMainDprId: null,
      comm: { ffcomments: "" },
    };
  },
  computed: {
    ...mapGetters(["mv_dprData/getDprPVId", "mv_dprData/getCurrentDprMainId", "mv_vesselActivity/getVesselActivities", "m_area/getAreas", "m_area/getSortedAreas", "m_configuration/getConfigurations", "m_activity/getActivitiesMap", "m_activity/getActivities", "m_mActivity/getMacroActivities", "m_cable/getCables", "m_actCfg/getActivityConfigurations", "m_estimate/getEstimates", "m_actCat/getActivityCategories", "m_tool/getTools", "mv_dprHeader/getDprHeader", "mv_comment/getComments", "mv_comment/getFFComment"]),
    ifNotCommulative() {
      let dprHeader = this["mv_dprHeader/getDprHeader"];
      return !(dprHeader || {}).cumulativeDpr;
    },

    items() {
      return this["mv_vesselActivity/getVesselActivities"];
    },
    firstActivityEntry() {
      return this.items.length == 0;
    },
    activities() {
      return this["m_activity/getActivities"];
    },
    macroActivities() {
      return this["m_mActivity/getMacroActivities"];
    },
    cables() {
      return this["m_cable/getCables"];
    },
    configurations() {
      return this["m_configuration/getConfigurations"];
    },
    areas() {
      return this["m_area/getAreas"];
    },
    estimates() {
      return this["m_estimate/getEstimates"];
    },
    activityCategories() {
      return this["m_actCat/getActivityCategories"];
    },
    tools() {
      return this["m_tool/getTools"];
    },

    /**
     * @returns `true` if the current project (the `pclsd` query param) is closed
     */
    isProjectClosed() {
      return 1 == this.$route.query.pclsd;
    },
  },
  mounted() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.fetchData();

    this["mv_comment/fetchComments"](this.currentMainDprId).then(() => {
      this.comm.ffcomments = this["mv_comment/getFFComment"];
      let entry = this["mv_comment/getComments"];
      this.comm.id = entry[0]?.id;
      this.comm.dprMainId = this.currentMainDprId;
    });
    this.resetActivity();
  },

  created() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;

    this.refreshActivities();
    this.resetActivity();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },

  methods: {
    ...mapMutations(["mHideLongLoader", "mShowErrorMessage"]),
    ...mapActions(["loadUserContext", "mv_dprHeader/fetchDprHeader", "m_area/fetchAreas", "m_activity/fetchActivities", "m_actCfg/fetchConfigurations", "m_mActivity/fetchMacroActivities", "m_cable/fetchCables", "m_configuration/fetchConfigurations", "m_estimate/fetchEstimates", "m_actCat/fetchActivityCategories", "m_tool/fetchTools", "mv_vesselActivity/fetchVesselActivities", "mv_vesselActivity/cloneVesselActivity", "mv_vesselActivity/createVesselActivity", "mv_vesselActivity/updateVesselActivity", "mv_vesselActivity/updateOldVesselActivity", "mv_vesselActivity/deleteVesselActivity", "mv_comment/fetchComments", "mv_comment/updateFFComment", "mv_comment/updateComment", "mv_comment/createComment"]),
    fetchData() {
      let pvId = this.currentPVId;
      this["m_actCfg/fetchConfigurations"]({ pvId: pvId, sInfo: true }).then((states) =>
        (states || []).forEach((e) => {
          this.invisibleStatesMap[e.columnDescription] = !e.visible;
          this.$refs.grid.fields.forEach((field) => {
            if (field.label === this.$t(e.columnDescription)) field.invisible = !e.visible;
          });
        })
      );
      this.$forceUpdate();

      this["m_estimate/fetchEstimates"]({
        pvId: this.currentPVId,
      });

      this["m_tool/fetchTools"](1);
      this["m_actCat/fetchActivityCategories"](1);
      this["m_cable/fetchCables"]({ pvId: pvId });
      this["m_area/fetchAreas"]({ pvId: pvId });
      this["m_configuration/fetchConfigurations"]({ pvId: pvId });
      this["m_activity/fetchActivities"]({ pvId: pvId });
      this["m_mActivity/fetchMacroActivities"]({ pvId: pvId });

      this.$log.debug("retrieving the dpr header for", this.currentMainDprId);
      this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId);
    },

    refreshActivities() {
      this.selectedRow = null;
      this.selectedIndex = null;

      this["mv_vesselActivity/fetchVesselActivities"]({ mainId: this.currentMainDprId }).then(() => {
        if (this.changedId) {
          this.$log.debug("intermediary time compiling changed. propagating changes ...");
          //this.propagateTimeChanges(this.changedId);
        }
      });
    },

    recomputeActivityFields(newVal, oldVal, row) {
      if (!newVal || newVal == "00000000-0000-0000-0000-000000000000") {
        return;
      }

      let activity = this.activitiesMap[newVal] || {};

      let activityCategory = this.activityCategoriesMap[activity.activityCategoryId] || {};
      row.activityCategory = activityCategory.description || null;

      var abbreviation = activityCategory ? activityCategory.abbreviation : null;
      row.production = abbreviation == "OP_T" ? Math.round(row.progress / row.deltaT / 60) : null;

      row.tool = (this.toolsMap[activity.toolId] || {}).description || null;
      this.onRotoEndChange(row.roToEndKp, row.roToEndKp, row);
    },

    resetActivity(item) {
      this.activity = Object.assign({}, item || this.activityDefault);
      this.activity.dprMainId = this.currentMainDprId;

      if (item) {
        this.activity.startTime = moment.utc(item.startTime).format(DATE_TIME_FORMAT);
        this.activity.endTime = moment.utc(item.endTime).format(DATE_TIME_FORMAT);
      }
    },

    initFirstActivity() {
      let dprHeader = this["mv_dprHeader/getDprHeader"];
      this.$log.debug("initiate first activity for DPR", dprHeader);

      let startDateTime = moment.utc(this.formatDate(dprHeader.dprDate, dprHeader.timeStart));
      this.activity.date = startDateTime.format(SRV_DATE_FORMAT);
      this.activity.timeCompiling = startDateTime.format(TIME_FORMAT);
      this.activity.deltaT = 0;

      this.$log.debug("try to detect the correct estimate", this.estimates);
      var estimates = this.estimates.filter((e) => e.id == dprHeader.estimateId);
      this.activity.estimate = estimates.length ? estimates[0].description : null;

      this.activity.startTime = startDateTime.format(SRV_DATE_TIME_FORMAT);
      this.activity.endTime = startDateTime.format(SRV_DATE_TIME_FORMAT);

      this.activity.roToStartKp = 0;
      this.activity.progress = this.activity.delta;

      return true;
    },

    initActivity() {
      let prevActivity = this.items[this.items.length - 1];
      let dprHeader = this["mv_dprHeader/getDprHeader"];

      // checking if we can add a new entry
      // let nextStartDateTime = moment.utc(prevActivity.startTime).add(1, 'minute')
      // let endDate = dprHeader.endDate || dprHeader.dprDate
      // let dprEndDateTime = moment.utc(this.formatDate(endDate, dprHeader.timeEnd))
      // if (nextStartDateTime.isAfter(dprEndDateTime)) {
      //   this.$log.debug('operation rejected. DPR End date time exceeded')
      //   return false
      // }

      this.$log.debug("initiate activity for DPR", dprHeader);

      var estimates = this.estimates.filter((e) => e.id == dprHeader.estimateId);
      this.activity.estimate = estimates.length ? estimates[0].description : null;

      let startDateTime = moment.utc(this.formatDate(prevActivity.date, prevActivity.timeCompiling)).add(1, "minute");
      this.activity.date = startDateTime.format(SRV_DATE_FORMAT);
      this.activity.timeCompiling = startDateTime.format(TIME_FORMAT);
      this.activity.deltaT = 1;

      this.activity.startTime = startDateTime.format(SRV_DATE_TIME_FORMAT);
      this.activity.endTime = startDateTime.format(SRV_DATE_TIME_FORMAT);

      // If [INP015].VE4 of the previous row = true then INP005 of the previous (valued) row, else INP004 of the previous row
      let activityStatus = (this.activitiesMap[prevActivity.activityId] || {}).status;
      this.$log.debug("categ activity found as ", prevActivity.activityId, "with status", activityStatus);

      this.activity.roToStartKp = activityStatus ? prevActivity.roToEndKp : prevActivity.roToStartKp;
      this.activity.vesselStartKp = activityStatus ? prevActivity.vesselEndKp : prevActivity.vesselStartKp;
      this.activity.rovStartKp = activityStatus ? prevActivity.rovEndKp : prevActivity.rovStartKp;
      this.activity.sheavelStartKp = activityStatus ? prevActivity.sheaveEndKp : prevActivity.sheaveStartKp;

      return true;
    },

    onRotoEndChange(newVal, oldVal, row) {
      this.$log.debug("Roto End Changed", oldVal, newVal, row);
      row.progress = newVal - row.roToStartKp;

      let rowIdx = this.items.findIndex((i) => i.$id == row.$id);
      this.$log.debug("row", rowIdx, "value changed. Trying to propage changes");

      setTimeout(() => {
        for (var i = rowIdx + 1; i < this.items.length; i++) {
          let prevItem = this.items[i - 1];
          let prevStatus = (this.activitiesMap[prevItem.activityId] || {}).status;

          this.items[i].roToStartKp = prevStatus ? prevItem.roToEndKp : prevItem.roToStartKp;
          this.items[i].roToEndKp = +this.items[i].roToStartKp + +this.items[i].progress;

          // XXX FIXME -- change to a bulk update?
          this.items[i].silentUpdate = true;
          this["mv_vesselActivity/updateVesselActivity"](this.items[i]);
        }
      });
    },

    preventValueEdit(newVal, oldVal, row) {
      if (row.itemIdx > 0) {
        return false;
      }
    },

    onDateChange(newVal, oldVal, row) {
      let dprHeader = this["mv_dprHeader/getDprHeader"];
      if (!dprHeader) {
        return false;
      }

      let endDate = moment.utc(dprHeader.endDate || dprHeader.dprDate);
      var newDate = moment.utc(newVal);

      if (newDate.isAfter(endDate)) {
        return false;
      }

      setTimeout(() => this.onTimeCompilingChange(row.timeCompiling, row.timeCompiling, row));
    },

    onTimeCompilingChange(newVal, oldVal, row) {
      let rowIdx = row.itemIdx || this.items.indexOf(row);
      let prevRow = this.items[rowIdx - 1];
      this.updateDeltaT(prevRow, row, newVal);

      setTimeout(() => {
        for (var i = rowIdx + 1; i < this.items.length; i++) {
          this.updateDeltaT(this.items[i - 1], this.items[i], null);
          this.items[i].silentUpdate = true;
          this["mv_vesselActivity/updateVesselActivity"](this.items[i]);
        }
      });
    },

    updateDeltaT(prevRow, row, newVal) {
      let dprHeader = this["mv_dprHeader/getDprHeader"];

      let prevDateTime = moment.utc(this.formatDate(dprHeader.dprDate, dprHeader.timeStart));
      if (prevRow) {
        prevDateTime = moment.utc(this.formatDate(prevRow.date, prevRow.timeCompiling));
      }

      let rowDateTime = moment.utc(this.formatDate(row.date, newVal || row.timeCompiling));
      var duration = moment.duration(rowDateTime.diff(prevDateTime));
      this.$log.debug("DeltaT(", prevDateTime.toLocaleString(), rowDateTime.toLocaleString(), ") = ", duration.asMinutes());
      row.deltaT = duration.asMinutes();
    },

    onVesselStartChange(/*newVal, oldVal, row*/) {
      // let rowIdx = row.itemIdx || this.items.indexOf(row)
      // if (rowIdx > 0) {
      //   return false
      // }
    },

    onVesselProgressChange(newVal, oldVal, row) {
      let rowIdx = row.itemIdx || this.items.indexOf(row);
      this.$log.debug("changed from " + oldVal + " to " + newVal);

      let foundArea = this.findArea(newVal);

      row.areaId = foundArea ? foundArea.id : null;
      row.areaName = foundArea ? foundArea.description : null;
      row.targetDepth = foundArea ? foundArea.targetDoB : null;
      row.targetSpeed = foundArea ? foundArea.averageTrenchingSpeed : null;

      if (!this.items[rowIdx + 1]) {
        return;
      }

      setTimeout(() => {
        var prevActivityStatus = (this.activitiesMap[row.activityId] || {}).status;
        this.items[rowIdx + 1].vesselStartKp = prevActivityStatus ? row.vesselEndKp : row.vesselStartKp;

        this.items[rowIdx + 1].silentUpdate = true;
        this["mv_vesselActivity/updateVesselActivity"](this.items[rowIdx + 1]);
      });
    },

    findArea(endKp) {
      var foundArea = null;

      for (var i = 0; i < this.areas.length; i++) {
        if (this.areas[i].toKP >= endKp) {
          foundArea = this.areas[i];
          break;
        }
      }

      return foundArea;
    },

    formatDate(dateTime, time) {
      const [date] = dateTime.split("T");
      return [date, time].join("T");
    },

    // -------------------------------------

    //#region Cell Dropdowns Map values

    yesNoMap() {
      return {
        null: "",
        true: this.$t("common.yes"),
        false: this.$t("common.no"),
      };
    },

    activityNameMap() {
      let map = {};
      this["m_activity/getActivities"].forEach((a) => (map[a.id] = a.description));
      return map;
    },

    macroActivitiesMap() {
      let map = {};
      this["m_mActivity/getMacroActivities"].forEach((a) => (map[a.id] = a.description));
      return map;
    },
    cablesMap() {
      let map = {};
      this["m_cable/getCables"].forEach((c) => (map[c.id] = c.description));
      return map;
    },
    configurationsMap() {
      let map = {};
      this["m_configuration/getConfigurations"].forEach((c) => (map[c.id] = c.description));
      return map;
    },
    //#endregion

    //#region Grid Helper Methods

    trimToEmpty(str) {
      if (null == str || typeof str == "undefined") {
        return "";
      }

      return str.replace(/\s+/g, "");
    },

    dateToText(val) {
      if (!val || val.trim() == "") {
        return moment(val).format("DD/MMM/YYYY");
      }
      if (moment(val, DATE_FORMAT, true).isValid()) {
        return moment(val).format("DD/MMM/YYYY");
      }
      return moment(val, SRV_DATE_FORMAT).format(DATE_FORMAT);
    },

    dateTimeToText(val) {
      if (!val || val.trim() == "") {
        return val;
      }
      if (moment(val, DATE_TIME_FORMAT, true).isValid()) {
        return val;
      }
      return moment(val, SRV_DATE_TIME_FORMAT).format(DATE_TIME_FORMAT);
    },

    textToDateTime(text) {
      if (!text || text.trim() == "") {
        return text;
      }
      if (moment(text, SRV_DATE_TIME_FORMAT, true).isValid()) {
        return text;
      }
      return moment(text, DATE_TIME_FORMAT).format(SRV_DATE_TIME_FORMAT);
    },

    textToDate(text) {
      if (!text || text.trim() == "") {
        return text;
      }
      if (moment(text, SRV_DATE_FORMAT, true).isValid()) {
        return text;
      }
      return moment(text, DATE_FORMAT).format(SRV_DATE_FORMAT);
    },

    validDateTime(content) {
      if (content === "") return "Mandatory field";
      if (!moment(content, DATE_TIME_FORMAT, true).isValid()) return "Invalid Date Time";
      return "";
    },

    validDate(content) {
      if (content === "") return "Mandatory field";

      var isValid = moment(content, SRV_DATE_FORMAT, true).isValid() || moment(content, DATE_FORMAT, true).isValid();
      if (!isValid) return "Invalid Date";
      return "";
    },

    validTime(content) {
      if (content === "") return "Mandatory field";
      if (!moment(content, TIME_FORMAT, true).isValid()) return "Invalid Time";
      return "";
    },

    validRotoEnd() {
      // if (content === '' || content === null) return 'Mandatory field'
      // if (isNaN(parseFloat(content))) return 'Valid number required'
      // if (content != oldContent && +content < +record.roToStartKp) return 'Value should be higher than ROTO Start'
      return "";
    },

    durationToText(val) {
      if (!val || val.trim() == "") {
        return val;
      }

      const [h, m] = val.split(":");
      return `${h}:${m}`;
    },

    textToDuration(text) {
      if (!text || text.trim() == "") {
        return text;
      }

      if (text.indexOf(":") === -1) {
        text += ":00";
      }

      return text;
    },

    numberToText(val) {
      if (!val) {
        return val;
      }
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    textToNumber(text) {
      if (!text) {
        return text;
      }

      return text.replace(/,/gi, "");
    },

    //#endregion

    onUpdate(records) {
      let record = records[0];
      if (this.trimToEmpty(record.err) != "" || this.trimToEmpty(record.rowerr)) {
        this.$log.error("failed to update record due to", record.err || record.rowerr);
        return;
      }
      this.selectedRow = this.items.filter((item) => item.$id == record.$id)[0];
      this.selectedIndex = this.items.indexOf(this.selectedRow);

      var data = Object.assign({}, this.selectedRow);
      data.dprMainId = this.currentMainDprId;
      data.silentUpdate = true;

      // lets recompute startTime = date + timeCompiling
      let startTime = moment.utc(this.formatDate(data.date, data.timeCompiling));
      data.startTime = startTime.format(SRV_DATE_TIME_FORMAT);

      if (this.items[this.selectedIndex].timeCompiling !== this.selectedRow.timeCompiling) {
        this.changedId = data.id;
      }

      if (data.id) {
        this["mv_vesselActivity/updateVesselActivity"](data);
      }

      if (!data.id) {
        this["mv_vesselActivity/createVesselActivity"](data).then((rsp) => {
          this.items[this.selectedIndex].id = rsp.id;
        });
      }
    },

    onSelect(selectedRows, isSelected) {
      this.selectedRow = null;
      this.selectedIndex = null;

      if (isSelected) {
        this.selectedIndex = selectedRows[0];
        this.selectedRow = this.items[this.selectedIndex];
      }
    },

    deleteRecord() {
      this.$log.debug("trying to delete row", this.selectedIndex);
      if (this.selectedIndex == null || this.selectedIndex == -1) {
        return;
      }

      let selIdx = this.selectedIndex;

      this.$confirm(this.$t("warning.delete") + " entry ?", {
        buttonTrueText: this.$t("common.delete"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((rsp) => {
        if (!rsp) {
          this.selectedIndex = null;
          return false;
        }

        this.selectedRow = this.items[selIdx];
        let nextRow = this.items[selIdx + 1];
        let prevRow = this.items[selIdx - 1];

        if (this.selectedRow && this.selectedRow.id) {
          this["mv_vesselActivity/deleteVesselActivity"](this.selectedRow).then(() => {
            this.$refs.grid.deleteRecord(selIdx);
            setTimeout(() => {
              this.$log.debug("record removed. Updating time compiling");
              if (nextRow) {
                this.updateDeltaT(prevRow, nextRow);

                let prvRow = prevRow ? prevRow : nextRow;
                if (!prevRow) {
                  this.$log.debug("no prev row detected. Resetting ROTO Start to 0");
                  nextRow.roToStartKp = 0;
                }

                this.onRotoEndChange(prvRow.roToEndKp, nextRow.roToEndKp, prvRow);
                this.onVesselProgressChange(prvRow.vesselStartKp, nextRow.vesselStartKp, prvRow);
                nextRow.silentUpdate = true;
                this["mv_vesselActivity/updateVesselActivity"](nextRow);
              }
            });
          });
        }

        this.selectedIndex = null;
      });

      this.resetActivity(this.selectedRow);
    },

    createItem() {
      this.resetActivity();

      var added = false;
      if (this.items.length == 0) {
        added = this.initFirstActivity();
      }

      if (this.items.length > 0) {
        added = this.initActivity();
      }

      if (added) {
        this.$refs.grid.newRecord(this.activity);
      }
    },
    cloneItems() {
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].silentUpdate = true;
        this["mv_vesselActivity/updateOldVesselActivity"](this.items[i]).then(this["mv_vesselActivity/cloneVesselActivity"](this.items[i]));
      }

      this.refreshActivities();
      this.readOnly = false;
    },
  },
};
</script>
